module.exports = __webpack_public_path__ + "static/media/coupon.06d42505.png";